import { createStore } from 'vuex';
import popups from './modules/popups';
import offer from './modules/offer';
import category from './modules/category';
import options from './modules/options';
import landing from './modules/landing';

export default createStore({
    state: {
        isDesktop: false,
        isMobMenuVisible: false,
        isAllowCookie: false,
    },
    getters: {
    },
    mutations: {
        setIsDesktop(state, data) {
            state.isDesktop = data;
        },
        setIsMobMenuVisible(state, data) {
          state.isMobMenuVisible = data;
        },
        setIsAllowCookie(state, data) {
          state.isAllowCookie = data;
        },
    },
    actions: {
        setIsDesktop(context, data) {
            context.commit('setIsDesktop', data);
        },
        setIsMobMenuVisible(context, data) {
          context.commit('setIsMobMenuVisible', data);
      },
      setIsAllowCookie(context, data) {
        context.commit('setIsAllowCookie', data);
      },
    },
    modules: {
        popups,
        offer,
        category,
        options,
        landing,
    },
});
